import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  ListGroupItem,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import CapabilitiesAddUsersSettings from './CapabilitiesAddUsersSettings';
import HelpIcon from '../../HelpIcon';

const AdminRoleEditCapabilitiesItem = ({
  capability,
  capabilityAttributes,
  capabilityName,
  checked,
  handleChangeCapabilityAttributes,
  handleCapabilitySwitch,
  disabled,
}) => {
  const intl = useIntl();

  return (
    <ListGroupItem>
      <Label for={`switchGroup-${capability}`} className="switch">
        <div className="switch-details">
          <span>
            {capabilityName}
            {capability === 'use_image_editor' && (
              <HelpIcon id="use-image-editor-tooltip" permanent={true}>
                {intl.formatMessage({
                  defaultMessage: 'Downloading files must be enabled',
                })}
              </HelpIcon>
            )}
            {capability === 'create_public_file' && (
              <HelpIcon id="create-public-file-tooltip" permanent={true}>
                {intl.formatMessage({
                  defaultMessage: 'Upload files must be enabled',
                })}
              </HelpIcon>
            )}
          </span>
        </div>
        <div className={classnames('switch-control input-inner', { disabled })}>
          <Input
            type="checkbox"
            name="groupUploadFile"
            id={`switchGroup-${capability}`}
            value="true"
            checked={checked}
            onChange={() => { handleCapabilitySwitch(capability); }}
            disabled={disabled}
          />
          <i />
        </div>
      </Label>
      {(capability === 'add_users' && checked) && (
        <CapabilitiesAddUsersSettings
          capabilityAttributes={capabilityAttributes}
          handleChangeCapabilityAttributes={handleChangeCapabilityAttributes}
        />
      )}
    </ListGroupItem>
  );
};

AdminRoleEditCapabilitiesItem.propTypes = {
  capability: PropTypes.string.isRequired,
  capabilityAttributes: PropTypes.object,
  capabilityName: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleCapabilitySwitch: PropTypes.func.isRequired,
  handleChangeCapabilityAttributes: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AdminRoleEditCapabilitiesItem.defaultProps = {
  capabilityAttributes: {},
  disabled: false,
};

export default AdminRoleEditCapabilitiesItem;
